"use strict";

exports.__esModule = true;
exports.AdvertWrapper = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2021 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
// JSDoc/Typescript imports
/**
* Encapsulates an advert's wrapper data, parsed from the Yospace extension data of a VAST document.
*
* An advert wrapper may contain a child wrapper, representing a the next level of advert wrapper data that
* contributed to the final advert.
* 
* @hideconstructor
*/
var AdvertWrapper = exports.AdvertWrapper = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(AdvertWrapper, _XmlValidation);
  function AdvertWrapper(id, creativeId, adSystem) {
    var _this;
    _this = _XmlValidation.call(this) || this;

    /** @private */
    _this.identifier = id;
    /** @private */
    _this.creativeIdentifier = creativeId;
    /** @private */
    _this.adSystem = adSystem;
    /** @private */
    _this.child = null;
    return _this;
  }

  /**
   * @return {string} the advert wrapper's adSystem.
   */
  var _proto = AdvertWrapper.prototype;
  _proto.getAdSystem = function getAdSystem() {
    return this.adSystem;
  }

  /**
   * @return {string} the advert's wrapper's creative identifier.
   */;
  _proto.getCreativeIdentifier = function getCreativeIdentifier() {
    return this.creativeIdentifier;
  }

  /**
   * @return {string} the advert wrapper identifier.
   */;
  _proto.getIdentifier = function getIdentifier() {
    return this.identifier;
  }

  /**
   * @return {AdvertWrapper} the advert wrapper's child, which may be null.
   */;
  _proto.getLineage = function getLineage() {
    return this.child;
  };
  _proto.isValid = function isValid() {
    var child = this;
    do {
      if (!child.identifier || child.identifier === "") {
        return false;
      }
      child = child.getLineage();
    } while (child);
    return true;
  };
  _proto.setChild = function setChild(child) {
    this.child = child;
  };
  return AdvertWrapper;
}(_XmlValidation2.XmlValidation);